// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__OLoE2","open":"MenuToggle_open__14SWd"};